import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import { CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormTextarea, CFormLabel, CButton, CCard } from '@coreui/react'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { Info } from 'lucide-react'
import Media from '../../components/shared/Media'

const DifferentialSuggestion = ({
  suggestions,
  parentId,
  onSuggestionsChange,
  setSaveResoanChange,
  setSubmitDescription,
  submitDescription,
  isStatementBox = true,
  handleAddStatementDescription,
  setActiveDescriptions,
  descriptionStatementId,
  handleFileStatementData,
  handleStatementFileSave,
  file,
  setFile,
  fileStatmentData,
  setParentAccordions,
  type,
  showTab,
  activeDescriptions,
  ApiCallingType,
  handelSubmit,
}) => {
  const [selectedData, setSelectedData] = useState({})
  const [activeKey, setActiveKey] = useState(null)
  const [formattedSuggestions, setFormattedSuggestions] = useState([])
  const [showMediaModel, setShowMediaModel] = useState(false)
  const [selectMedia, setSelectMedia] = useState(null)
  const [highlightedIndex, setHighlightedIndex] = useState(null)

  useEffect(() => {
    let transformedSuggestions = []
    if (Array.isArray(suggestions) && suggestions.length > 0) {
      if (typeof suggestions[0] === 'string') {
        transformedSuggestions = suggestions.map((item) => ({
          name: item,
          description: '',
        }))
      } else {
        transformedSuggestions = suggestions
      }
    }
    setFormattedSuggestions(transformedSuggestions)

    const initialData = {}
    transformedSuggestions.forEach((suggestion) => {
      initialData[suggestion.name] = suggestion.description || ''
    })
    setSelectedData(initialData)
  }, [suggestions])

  const toggleAccordion = (index) => {
    setActiveKey(activeKey === index ? null : index)
  }

  const debounceTimeout = useRef(null)
  const debounce = (func, delay) => {
    clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(func, delay)
  }

  const handleDescriptionChange = (suggestionName, value) => {
    setSelectedData((prev) => {
      const updatedData = {
        ...prev,
        [suggestionName]: value,
      }
      debounce(() => {
        const formattedSuggestions = Object.keys(updatedData).map((key) => ({
          name: key,
          description: updatedData[key],
        }))
        onSuggestionsChange(formattedSuggestions, parentId)
      }, 300)
      return updatedData
    })
  }

  const handleConvertAndOpenMedia = () => {
    if (selectMedia?.attached) {
      const convertedData = Object.entries(selectMedia?.attached).flatMap(([type, files]) =>
        files.map((file) => ({
          url: typeof file === 'object' ? file.url : file,
          type,
          fileName: typeof file === 'object' ? file.fileName || '' : file.split('/').pop(),
        })),
      )

      setFile(convertedData)
    } else {
      setFile([])
    }
    setShowMediaModel(true)
  }

  useEffect(() => {
    if (selectMedia) {
      handleConvertAndOpenMedia()
    }
  }, [selectMedia])

  return (
    <div>
      <CAccordion activeItemKey={activeKey}>
        {formattedSuggestions?.map((suggestion, index) =>
          isStatementBox ? (
            <CAccordionItem
              key={index}
              className="border-0 mt-2 differential-suggestion-theme__accordion-item"
              style={{
                borderRadius: '8px',
              }}
            >
              <CAccordionHeader className="differential-suggestion-theme__accordion-header" onClick={() => toggleAccordion(index)}>
                {suggestion.name}
              </CAccordionHeader>
              <CAccordionBody className="d-flex flex-column gap-2 differential-suggestion-theme__accordion-body">
                <div>
                  <CFormLabel>Description</CFormLabel>
                  <CFormTextarea placeholder={`Enter description for ${suggestion.name}`} value={selectedData[suggestion.name] || ''} onChange={(e) => handleDescriptionChange(suggestion.name, e.target.value)} />
                </div>
              </CAccordionBody>
            </CAccordionItem>
          ) : (
            <CCard
              className="d-flex align-items-center justify-content-between w-100 flex-row p-2 differential-suggestion-theme__card"
              key={index}
              style={{
                borderRadius: '10px',
                outline: index === descriptionStatementId?.orderIndex && descriptionStatementId.parentId === parentId && activeDescriptions ? '2px solid rgba(14, 106, 236, 0.8)' : 'none',
                padding: '15px 20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'outline 0.3s ease, box-shadow 0.3s ease',
                fontSize: '1rem',
              }}
              onClick={() => {
                if (showTab) {
                  setActiveDescriptions('statement')
                  handleAddStatementDescription(
                    {
                      parentId,
                      orderIndex: index,
                      name: suggestion.name,
                    },
                    suggestion?.description ?? '',
                  )
                }
              }}
            >
              <p className="differential-suggestion-theme__card-text">{suggestion.name}</p>
              <div className="d-flex flex-row" style={{ gap: '4px' }}>
                <Info
                  size={22}
                  strokeWidth={1.5}
                  className="differential-suggestion-theme__icon"
                  style={{
                    color: highlightedIndex === index ? '#0d6efd' : '',
                    backgroundColor: highlightedIndex === index ? 'rgba(13, 110, 253, 0.2)' : '',
                    borderRadius: '50%',
                    transition: 'all 0.3s ease-in-out',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleAddStatementDescription(
                      {
                        parentId,
                        orderIndex: index,
                        name: suggestion.name,
                      },
                      suggestion?.description ?? '',
                    )
                    setActiveDescriptions('statement')
                    setHighlightedIndex(index)
                    setTimeout(() => setHighlightedIndex(null), 2000)
                  }}
                />

                <div
                  onClick={() => {
                    ;(setSelectMedia(suggestion),
                      handleConvertAndOpenMedia(),
                      handleFileStatementData({
                        parentId,
                        attachedIndex: index,
                        name: suggestion.name || suggestion,
                      }))
                  }}
                  className="d-flex justify-content-center align-items-center rounded-circle differential-suggestion-theme__media-trigger pe-accordion-badge"
                  style={{ width: '22px', height: '22px', fontSize: '12px', border: '1.5px solid var(--ui-text-primary, #ffffff)', color: 'var(--ui-text-primary, #ffffff)' }}
                >
                  e
                </div>
              </div>
            </CCard>
          ),
        )}
        {showMediaModel && (
          <div>
            <Media
              showMediaModel={showMediaModel}
              setShowMediaModel={setShowMediaModel}
              parentId={parentId}
              handleFileSave={handleStatementFileSave}
              file={file}
              setFile={setFile}
              fileStatmentData={fileStatmentData}
              attachedType="statement"
              setParentAccordions={setParentAccordions}
              type={type}
              setSelectMedia={setSelectMedia}
              showTab={showTab}
              ApiCallingType={ApiCallingType}
              handelSubmit={handelSubmit}
              differentModuleCopyFunctionality={true}
            />
          </div>
        )}
      </CAccordion>
    </div>
  )
}

export default DifferentialSuggestion
